import dayjs from 'dayjs'

const DAY_NORMAL_FORMAT = 'YYYY-MM-DD HH:mm:ss'

function formatTimestamp(val) {
  if(/^\d{10}$/.exec(String(val))) {
    val = val*1000
  }
  return val
}

const format = {

  // 日期
  day(val, format) {
    val = formatTimestamp(val)
    return dayjs(val).format(format)
  },
  day_normal(val) {
    val = formatTimestamp(val)
    return val ? dayjs(val).format(DAY_NORMAL_FORMAT) : ''
  },

  money(val) {
    val = Number(val/100).toFixed(2)
    return val == 0 ? 0 : val
  },

  // 金钱 
  money_relative(val) {
    val = format.money(val)
    val = String(val)
    if(/^(\+|-)+/.exec(val)) {
      return val
    }
    if(Number(val) > 0) {
      return '+' + val
    }
    else if(Number(val) < 0) {
      return '-' + val
    }
  }
}


export default format